import * as React from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import {
  getFromLocalStorage,
  setToLocalStorage,
} from "../../utils/common-utils";
import Swal from "sweetalert2";
import { ChangePasswordPrivate, LogoutUser } from "../../api/Api";
import LogoSmall from "../../assets/images/logo_small.png";
import LogoMain from "../../assets/images/altruist_logo.png";
import logomobile from "../../assets/images/logo_mobile.png";
import CustomModal from "../../components/Modal/CustomModal";
import "./header.css";
import UpdateProfile from "../../components/userProfile/updateProfile";

export default function Header() {
  const navigate = useNavigate();
  const { setContextStates } = React.useContext(AppContext);
  const userData = getFromLocalStorage("userData");
  console.log("userDate", userData);
  const [changePasswordModal, setChangePasswordModal] = React.useState(false);
  const [updateProfileModal, setUpdateProfileModal] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showPassword1, setShowPassword1] = React.useState(false);
  const [showPassword2, setShowPassword2] = React.useState(false);
  const [showUserMenu, setShowUserMenu] = React.useState(false);
  const [resetPassword, setResetPassword] = React.useState({
    existingPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [loader, setLoader] = React.useState(false);
  const [profileDetails, setProfileDetails] = React.useState({
    firstName: userData?.firstName || "",
    lastName: userData?.lastName || "",
    email: userData?.email || "",
    username: userData?.username || "",
    mobile: userData?.mobileNo || "",
    streetAddress: userData?.streetAddress || "",
    state: userData?.state || "",
    city: userData?.city || "",
    country: userData?.country || "",
    cpDetailsList: userData?.cpDetailsList || [],
    // Add other fields as needed
  });
  const pass = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
  console.log("profileDetails", profileDetails);

  // Update the sidebar toggle state and mobile detection
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(true);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);

  // Toggle sidebar function
  const toggleSidebar = () => {
    const body = document.body;
    const currentClasses = body.className;
    
    if (currentClasses.includes('sidebar-open')) {
      // If sidebar is open, close it
      body.className = currentClasses.replace('sidebar-open', 'sidebar-collapse');
      setIsSidebarOpen(false);
    } else {
      // If sidebar is closed, open it
      body.className = 'skin-blue sidebar-mini mat-typography sidebar-open';
      setIsSidebarOpen(true);
    }
  };

  // Handle window resize
  React.useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      if (mobile) {
        document.body.className = 'skin-blue sidebar-mini mat-typography sidebar-collapse';
        setIsSidebarOpen(false);
      }
    };

    // Set initial classes - open by default for desktop
    if (window.innerWidth > 768) {
      document.body.className = 'skin-blue sidebar-mini mat-typography sidebar-open';
    } else {
      document.body.className = 'skin-blue sidebar-mini mat-typography sidebar-collapse';
    }
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = async () => {
    // Show confirmation dialog first
    const result = await Swal.fire({
      title: "Logout Confirmation",
      text: "Are you sure you want to logout?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, logout",
      cancelButtonText: "Cancel",
      reverseButtons: false,
    });

    // If user confirms logout
    if (result.isConfirmed) {
      let payload = {
        userId: getFromLocalStorage("userData")?.id,
      };
      await LogoutUser(payload);
      // Save rememberedCredentials before clearing localStorage
      const rememberedCredentials = getFromLocalStorage(
        "rememberedCredentials"
      );

      // Clear localStorage
      localStorage.clear();

      // Restore rememberedCredentials if it existed
      if (rememberedCredentials) {
        setToLocalStorage("rememberedCredentials", rememberedCredentials);
      }

      navigate("/");
      Swal.fire({
        text: "Logged Out Successfully",
        icon: "success",
        confirmButtonText: "OK",
      });

      setContextStates((prev) => {
        return {
          ...prev,
          actualToken: "",
        };
      });
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    const { existingPassword, newPassword, confirmPassword } = resetPassword;
    if (
      !existingPassword ||
      !newPassword ||
      (newPassword && !pass.test(newPassword)) ||
      !confirmPassword ||
      newPassword !== confirmPassword
    ) {
      setError(true);
    } else {
      setError(false);
      setLoader(true);
      let payload = {
        userId: userData?.id,
        updateId: null,
        oldPassword: existingPassword,
        newPassword: newPassword,
        // emailId: userData?.email,
      };
      const response = await ChangePasswordPrivate(payload);
      console.log("response", response);
      setLoader(false);
      if (response?.statusDescription?.status == 200) {
        setChangePasswordModal(false);
        setError(false);
        setResetPassword({
          existingPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
        Swal.fire({
          text: response?.statusDescription?.description,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          text: response?.statusDescription?.description,
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    }
  };

  // Determine if it's admin profile (similar to adminClass logic)
  const isAdminProfile = profileDetails.cpDetailsList.length > 0;
  const handleUserMenuClick = () => {
    setShowUserMenu(!showUserMenu);
    console.log("showUserMenu", showUserMenu);
  };

  // Add useRef for click outside handling
  const userMenuRef = React.useRef(null);

  // Handle click outside to close menu
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="wrapper">
      <header className="main-header d-md-block">
        {/* Logo */}
        <a className="logo d-none d-md-block" href="#">
          <span className="logo-mini" >
            <img src={logomobile} alt="logo_small" style={{ maxWidth: "33px", minWidth: "33px" }} />
          </span>
          <span className="logo-lg">
            <img src={LogoMain} alt="logo" className="img-responsive d-none d-md-block mt-3" />
            {/* <img src={logomobile} alt="logo" className="img-responsive mob_img d-block d-md-none position-absolute" /> */}
          </span>
        </a>

        <nav className="navbar navbar-expand-lg navbar-static-top">
          <div className="sidebar-toggle" onClick={toggleSidebar} role="button">
            <i className="fas fa-bars text-white"></i>
          </div>

          <div className="navbar-custom-menu">
            <ul className="nav navbar-nav">
              <li className="user-menu">
                <span className="hidden-xs">
                  Welcome {getFromLocalStorage("userData")?.firstName}{" "}
                  {getFromLocalStorage("userData")?.lastName} !
                </span>
              </li>
              <li className={`li_user link ${showUserMenu ? 'active' : ''}`} ref={userMenuRef}>
                <span onClick={handleUserMenuClick}>
                  <i className="fa fa-user"></i>
                </span>
                <ul>
                  <li>
                    <a onClick={() => {
                      setChangePasswordModal(true);
                      setShowUserMenu(false);
                    }}>
                      <i className="fa fa-key"></i>Change Password
                    </a>
                  </li>
                  <li>
                    <a onClick={() => {
                      setUpdateProfileModal(true);
                      setShowUserMenu(false);
                    }}>
                      <i className="fa fa-user"></i>Update Profile
                    </a>
                  </li>
                  <li>
                    <a onClick={() => {
                      handleLogout();
                      setShowUserMenu(false);
                    }}>
                      <i className="fa fa-sign-out"></i>Logout
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
      </header>

      <CustomModal
        show={changePasswordModal}
        onHide={() => {
          setChangePasswordModal(false);
          setError(false);
          setResetPassword({
            existingPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
        }}
        title="Change Password"
        size="lg"
        dialogClassName="custom-modal-class"
      >
        {/* <div className="modal-body"> */}
          <form className="form-horizontal" onSubmit={handleChangePassword}>
            <div className="row w-100 m-0">
              <div className="col-sm-4">
                <div className="form-group">
                  <label>Existing Password</label>
                  <div class="input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className={`form-control ${error && !resetPassword.existingPassword
                        ? "is-invalid"
                        : ""
                        }`}
                      placeholder="Existing Password"
                      value={resetPassword.existingPassword}
                      onChange={(e) =>
                        setResetPassword((prev) => ({
                          ...prev,
                          existingPassword: e.target.value,
                        }))
                      }
                    />
                    <span
                      class="input-group-text"
                      id="basic-addon2"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i
                        className={`fa fa-${!showPassword ? "eye-slash" : "eye"
                          }`}
                      ></i>
                    </span>
                  </div>
                  {error && !resetPassword.existingPassword && (
                    <div className="invalid-feedback d-block error">
                      Please enter your existing password
                    </div>
                  )}
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>New Password</label>
                  <div class="input-group">
                    <input
                      type={showPassword1 ? "text" : "password"}
                      className={`form-control ${error &&
                        (!resetPassword.newPassword ||
                          !pass.test(resetPassword.newPassword))
                        ? "is-invalid"
                        : ""
                        }`}
                      placeholder="New Password"
                      value={resetPassword.newPassword}
                      onChange={(e) =>
                        setResetPassword((prev) => ({
                          ...prev,
                          newPassword: e.target.value,
                        }))
                      }
                    />
                    <span
                      class="input-group-text"
                      id="basic-addon2"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPassword1(!showPassword1)}
                    >
                      <i
                        className={`fa fa-${!showPassword1 ? "eye-slash" : "eye"
                          }`}
                      ></i>
                    </span>
                  </div>
                  {error &&
                    (!resetPassword.newPassword ||
                      !pass.test(resetPassword.newPassword)) && (
                      <div className="invalid-feedback d-block error">
                        {!resetPassword.newPassword
                          ? "Please enter a new password"
                          : !pass.test(resetPassword.newPassword)
                            ? "Password must has at least 8 characters that include at least 1 lowercase character, 1 uppercase characters, 1 number, and 1 special character"
                            : ""}
                      </div>
                    )}
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>Confirm New Password</label>
                  <div class="input-group">
                    <input
                      type={showPassword2 ? "text" : "password"}
                      className={`form-control ${error && !resetPassword.confirmPassword
                        ? "is-invalid"
                        : ""
                        }`}
                      placeholder="Confirm New Password"
                      value={resetPassword.confirmPassword}
                      onChange={(e) =>
                        setResetPassword((prev) => ({
                          ...prev,
                          confirmPassword: e.target.value,
                        }))
                      }
                    />
                    <span
                      class="input-group-text"
                      id="basic-addon2"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPassword2(!showPassword2)}
                    >
                      <i
                        className={`fa fa-${!showPassword2 ? "eye-slash" : "eye"
                          }`}
                      ></i>
                    </span>
                  </div>
                  {error &&
                    (!resetPassword.confirmPassword ||
                      resetPassword.confirmPassword !==
                      resetPassword.newPassword) && (
                      <div className="invalid-feedback d-block error">
                        {!resetPassword.confirmPassword
                          ? "Please enter your confirm new password"
                          : resetPassword.confirmPassword !==
                            resetPassword.newPassword
                            ? "New password and confirm password do not match"
                            : ""}
                      </div>
                    )}
                </div>
              </div>
              <span className="password-title">Password must have:</span>
            <ul className="password-requirements">
              <li>At least 8 characters</li>
              <li>1 lowercase character</li>
              <li>1 uppercase character</li>
              <li>1 number</li>
              <li>1 special character</li>
            </ul>
            </div>
            {/* <span className="password-title">Password must have:</span>
            <ul className="password-requirements">
              <li>At least 8 characters</li>
              <li>1 lowercase character</li>
              <li>1 uppercase character</li>
              <li>1 number</li>
              <li>1 special character</li>
            </ul> */}
            <div className="modal-footer pb-0 border-0 justify-content-between buttons_divs">
              <button
                type="button"
                className="btn btn-danger btn-raised m-0"
                onClick={() => {
                  setChangePasswordModal(false);
                  setError(false);
                  setResetPassword({
                    existingPassword: "",
                    newPassword: "",
                    confirmPassword: "",
                  });
                }}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary btn-raised">
                Submit
              </button>
            </div>
          </form>
        {/* </div> */}
      </CustomModal>

      <CustomModal
        show={updateProfileModal}
        onHide={() => setUpdateProfileModal(false)}
        title="Update Your Profile"
        size="lg"
        dialogClassName="custom-modal-class"
      >
        <UpdateProfile onHide={() => setUpdateProfileModal(false)} />
      </CustomModal>
    </div>
  );
}
